const u = (id, w = 1400) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  heroTiger: "https://images.unsplash.com/photo-1698382439843-ca033a6079c0?crop=entropy&cs=srgb&fm=jpg&w=2000&q=85",
  tigerJungle: "https://images.unsplash.com/photo-1730014392621-10de7b9bc20f?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  heritageTemple: "https://images.unsplash.com/photo-1554554497-0095c34db3ec?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  glamping: "https://images.unsplash.com/photo-1719933961919-e73f3fbcc087?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  forestMist: "https://images.unsplash.com/photo-1550699148-3667307b6f54?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
  tiger: u("1561731216-c3a4d99437d5"),
  deer: u("1484406566174-9da000fda645"),
  safari: u("1516426122078-c23e76319801"),
  eagle: u("1459262838948-3e2de6c1ec80"),
  birdSun: u("1452570053594-1b985d6ea890"),
  bird: u("1444464666168-49d633b86797"),
  forestSun: u("1447752875215-b2761acb3c5d"),
  forestPath: u("1441974231531-c6227db76b6e"),
  forestDark: u("1448375240586-882707db888b"),
  forestMist2: u("1511497584788-876760111969"),
  forestLight: u("1523712999610-f77fbcfc3843"),
  forestDeep: u("1542273917363-3b1817f69a2d"),
  forestFog: u("1440342359743-84fcb8c21f21"),
  forestRoad: u("1503435980610-a51f3ddfee50"),
  forestTall: u("1425913397330-cf8af2ff40a1"),
  forestGreen: u("1418065460487-3e41a6c84dc5"),
  canopy: u("1502082553048-f009c37129b9"),
  fogHills: u("1470071459604-3b5ec3a7fe05"),
  mountainSun: u("1469474968028-56623f02e42e"),
  mountainLake: u("1501785888041-af3ef285b470"),
  mountains: u("1506905925346-21bda4d32df4"),
  mountainRange: u("1464822759023-fed622ff2c3b"),
  valley: u("1493246507139-91e8fad9978e"),
  valley2: u("1426604966848-d7adac402bff"),
  rocks: u("1483728642387-6c3bdd6c93e5"),
  river: u("1482938289607-e9573fc25ebb"),
  lake: u("1439066615861-d1af74d74000"),
  waterfall: u("1433086966358-54859d0ed716"),
  waterfall2: u("1432405972618-c60b0225b8f9"),
  canoe: u("1476514525535-07fb3b4ae5f1"),
  meadowSunset: u("1472214103451-9374bd1c798e"),
  fieldSunset: u("1470252649378-9c29740c9fa8"),
  hiker: u("1551632811-561732d1e306"),
  hiker2: u("1508672019048-805c876b67e2"),
  cliff: u("1526772662000-3f88f10405ff"),
  trek: u("1501555088652-021faa106b9b"),
  summit: u("1500530855697-b586d89ba3ee"),
  tentStars: u("1504280390367-361c6d9f38f4"),
  nightStars: u("1519681393784-d120267933ba"),
  roadTrip: u("1469854523086-cc02fe5d8800"),
  mountainRoad: u("1465188162913-8fb5709d6d57"),
  taj: u("1524492412937-b28074a5d7da"),
  taj2: u("1548013146-72479768bada"),
  taj3: u("1564507592333-c60657eea523"),
  indiaGate: u("1587474260584-136574528ed5"),
  city: u("1449824913935-59a10b8d2000"),
  suv: u("1533473359331-0135ef1b58bf"),
  jeep: u("1568605117036-5fe5e7bab0b7"),
  carDark: u("1549317661-bd32c8ce0db2"),
  carRoad: u("1449965408869-eaa3f722e40d"),
  carNight: u("1502877338535-766e1452684a"),
  carDrive: u("1493238792000-8113da705763"),
  moto: u("1558981403-c5f9899a28bc"),
  moto2: u("1449426468159-d96dbf08f19f"),
  moto3: u("1568772585407-9361f9bf3a87"),
};

export const FALLBACK_IMG = IMG.forestDark;

export const CONTACT = {
  phone: "+91 9717029579",
  phoneRaw: "+919717029579",
  whatsapp: "https://wa.me/919717029579?text=Hi%20HIDDENBIOMES%2C%20I%27d%20like%20to%20plan%20a%20journey.",
  email: "info@hiddenbiomes.com",
  address: "0/12 A, Shreeji Valley, Shreeji Height, Mardana, Bhicholi Hapsi, Indore, Madhya Pradesh – 452016, India",
  gstin: "23AATFH7113E1ZI",
  mapEmbed:
    "https://www.google.com/maps?q=Shreeji%20Heights%2C%20Mardana%2C%20Bhicholi%20Hapsi%2C%20Indore%2C%20Madhya%20Pradesh%20452016&output=embed",
};

export const DESTINATIONS = [
  { name: "Kanha", desc: "Sal forests and golden meadows of the reserve that inspired The Jungle Book.", cat: "Wildlife", img: IMG.forestSun },
  { name: "Bandhavgarh", desc: "One of the highest densities of wild tigers found anywhere on Earth.", cat: "Wildlife", img: IMG.tiger },
  { name: "Pench", desc: "Teak forests and the river that gave Mowgli his jungle.", cat: "Wildlife", img: IMG.forestDark },
  { name: "Satpura", desc: "Walking safaris and silent backwaters inside a biosphere reserve.", cat: "Wildlife", img: IMG.forestMist2 },
  { name: "Panna", desc: "A river of diamonds and one of conservation's great comeback stories.", cat: "Wildlife", img: IMG.river },
  { name: "Kuno", desc: "India's newest wilderness — the historic home of the cheetah.", cat: "Wildlife", img: IMG.meadowSunset },
  { name: "Pachmarhi", desc: "The Satpura's hill station of waterfalls, ravines and ancient cave art.", cat: "Nature", img: IMG.waterfall },
  { name: "Khajuraho", desc: "UNESCO temples carved with a thousand years of extraordinary artistry.", cat: "Heritage", img: IMG.heritageTemple },
  { name: "Orchha", desc: "A medieval capital frozen in time on the banks of the Betwa.", cat: "Heritage", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/23/Jahangir_Mahal_of_Orchha_in_monsoon.jpg/1920px-Jahangir_Mahal_of_Orchha_in_monsoon.jpg" },
  { name: "Mandu", desc: "A ruined city of romance and monsoon palaces among the Vindhyas.", cat: "Heritage", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/d/de/Jahaz_Mahal_01.jpg/1920px-Jahaz_Mahal_01.jpg" },
  { name: "Maheshwar", desc: "Ghats, handlooms and fortresses along the sacred Narmada.", cat: "Heritage", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/7c/Ghats_of_Maheshwar_01.jpg/1920px-Ghats_of_Maheshwar_01.jpg" },
  { name: "Ujjain", desc: "One of Hinduism's seven sacred cities, on the banks of the Shipra.", cat: "Spiritual", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/7/75/Mahakaleshwar_Temple%2C_Ujjain.jpg/1920px-Mahakaleshwar_Temple%2C_Ujjain.jpg" },
  { name: "Omkareshwar", desc: "A river-island Jyotirlinga shaped like the sacred syllable Om.", cat: "Spiritual", img: IMG.lake },
  { name: "Indore", desc: "The food-loving, fast-beating commercial heart of Madhya Pradesh.", cat: "City", img: IMG.city },
  { name: "Bhopal", desc: "The city of lakes, nawabi heritage and world-class museums.", cat: "City", img: IMG.fieldSunset },
  { name: "Jabalpur", desc: "River city and gateway to the marble canyons of the Narmada.", cat: "Nature", img: IMG.valley2 },
  { name: "Bhedaghat", desc: "The Narmada carving its way through a gorge of moon-white marble.", cat: "Nature", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/2/2f/Bhedaghat_%28Marble_Rocks%29_Near_Jabalpur.jpg/1920px-Bhedaghat_%28Marble_Rocks%29_Near_Jabalpur.jpg" },
  { name: "Sanchi", desc: "The Great Stupa — Buddhism's oldest story told in stone.", cat: "Heritage", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/9/9e/Great_Sanchi_Stupa_%283%29.jpg/1920px-Great_Sanchi_Stupa_%283%29.jpg" },
  { name: "Bhimbetka", desc: "Rock shelters painted by human hands thirty thousand years ago.", cat: "Heritage", img: IMG.rocks },
  { name: "Amarkantak", desc: "Source of the Narmada, wrapped in deep sal forest and stillness.", cat: "Nature", img: IMG.mountainSun },
  { name: "Shivpuri", desc: "Royal hunting forests, still lakes and grand marble chhatris.", cat: "Nature", img: IMG.forestDeep },
  { name: "Chanderi", desc: "A hill town of weavers, forts and moonlit handloom sarees.", cat: "Heritage", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/e/e9/Chanderi_Fort-Chanderi-Madhya_Pradesh-DSC_0268.jpg/1920px-Chanderi_Fort-Chanderi-Madhya_Pradesh-DSC_0268.jpg" },
  { name: "Burhanpur", desc: "Forgotten Mughal splendour resting on the banks of the Tapti.", cat: "Heritage", img: "https://thumb.wikimedia.org/wikipedia/commons/thumb/3/36/Aahukhana_burhanpur_%28Madhya_Pradesh%2C_India%29.JPG/1920px-Aahukhana_burhanpur_%28Madhya_Pradesh%2C_India%29.JPG" },
];

export const EXPERIENCES = [
  { name: "Tiger Safaris", desc: "Track the royal Bengal tiger through the great central Indian forests.", img: IMG.tiger, icon: "paw" },
  { name: "Jungle Expeditions", desc: "Multi-day journeys deep into protected tiger country.", img: IMG.forestDark, icon: "compass" },
  { name: "Wildlife Tours", desc: "Leopards, sloth bears, wild dogs and herds of gaur.", img: IMG.safari, icon: "binoculars" },
  { name: "Camping", desc: "Nights under forest skies, far from the nearest streetlight.", img: IMG.tentStars, icon: "tent" },
  { name: "Birdwatching", desc: "Over 500 species — from hornbills to paradise flycatchers.", img: IMG.bird, icon: "bird" },
  { name: "Nature Experiences", desc: "Slow mornings, forest walks and riverside stillness.", img: IMG.forestSun, icon: "leaf" },
  { name: "Forest Escapes", desc: "Quiet lodges and tree-canopy hideaways in the green.", img: IMG.forestMist2, icon: "trees" },
  { name: "Wildlife Photography", desc: "Golden-hour frames guided by people who know the forest.", img: IMG.deer, icon: "camera" },
];

export const TOURS = [
  {
    slug: "kanha-wildlife-escape",
    name: "Kanha Wildlife Escape",
    destination: "Kanha National Park",
    duration: "3 Nights / 4 Days",
    price: "Price on Request",
    img: IMG.forestSun,
    tagline: "Meadows, sal forests and the royal Bengal tiger.",
    overview:
      "Kanha is the forest that inspired The Jungle Book — rolling meadows, towering sal trees and some of the finest tiger habitat in Asia. This escape pairs multiple private safaris with slow evenings at a handpicked jungle lodge.",
    highlights: [
      "Four private jeep safaris across Kanha's core zones",
      "Sunset over the meadows from Bamni Dadar",
      "Naturalist-led interpretation on every drive",
      "Visit to a Baiga village and local museum",
      "Stay at a boutique jungle lodge near the gate",
    ],
    itinerary: [
      { day: "Day 1", title: "Into the Sal Forest", detail: "Arrive via Jabalpur, transfer to your lodge on the forest edge. Evening orientation walk and campfire dinner." },
      { day: "Day 2", title: "First Safaris", detail: "Dawn and afternoon safaris in the Kanha and Kisli zones — tiger, leopard, barasingha and wild dog country." },
      { day: "Day 3", title: "Meadows & Villages", detail: "Morning safari in Mukki zone, afternoon with the Baiga community, sunset at Bamni Dadar." },
      { day: "Day 4", title: "Farewell Drive", detail: "Final morning safari and departure transfer with packed breakfast." },
    ],
    bestTime: "October to June (peak sightings November – April)",
    accommodation: "Handpicked jungle lodges and boutique resorts near the Kisli or Mukki gates.",
    transport: "Private air-conditioned SUV transfers with a dedicated open safari gypsy.",
    activities: ["Jeep Safari", "Birdwatching", "Nature Walks", "Village Visit", "Stargazing"],
    important: [
      "Safari permits are subject to availability — early enquiry is strongly recommended.",
      "Core zones remain closed on Wednesday afternoons.",
      "A valid government photo ID is mandatory for safari entry.",
      "Park closes for monsoon, roughly July to September.",
    ],
    gallery: [IMG.forestSun, IMG.tiger, IMG.deer, IMG.forestPath],
    faqs: [
      { q: "What are the chances of seeing a tiger?", a: "Kanha offers among the best tiger sighting records in India, but the forest writes its own script — every drive is guided for the best possible chances." },
      { q: "Is this tour suitable for children?", a: "Yes, children above five generally love safari life. Lodges offer family cottages and flexible meal timings." },
      { q: "What should I pack?", a: "Neutral-coloured clothing, a warm layer for dawn drives, a hat, sunscreen, and binoculars if you have them." },
      { q: "Can the itinerary be customised?", a: "Absolutely. Extra safari drives, zone preferences and lodge upgrades can all be arranged on request." },
    ],
  },
  {
    slug: "bandhavgarh-tiger-expedition",
    name: "Bandhavgarh Tiger Expedition",
    destination: "Bandhavgarh National Park",
    duration: "3 Nights / 4 Days",
    price: "Price on Request",
    img: IMG.tiger,
    tagline: "The densest tiger territory on the planet.",
    overview:
      "Bandhavgarh holds one of the highest densities of wild tigers ever recorded. Beneath its ancient fort cliffs, meadows and sal valleys, this expedition maximises time inside the park with expert trackers and naturalists.",
    highlights: [
      "Four safaris across Tala, Magadhi and Khitauli zones",
      "The highest wild tiger density in India",
      "The 2,000-year-old Bandhavgarh fort backdrop",
      "Expert tracker and naturalist on every drive",
      "Photography-friendly open gypsy safaris",
    ],
    itinerary: [
      { day: "Day 1", title: "Arrival at Tiger Country", detail: "Transfer from Jabalpur or Umaria to your lodge. Evening briefing on the park's legendary tiger lineages." },
      { day: "Day 2", title: "Tala & the Fort", detail: "Dawn safari in Tala zone beneath the fort cliffs, afternoon drive in Magadhi's grasslands." },
      { day: "Day 3", title: "Khitauli Wilds", detail: "Full day of safaris with a village walk between drives and storytelling by the fire." },
      { day: "Day 4", title: "Last Light", detail: "Final morning safari and onward transfer after brunch." },
    ],
    bestTime: "October to June (February – May for peak sightings)",
    accommodation: "Premium wildlife lodges at Tala with forest-view cottages.",
    transport: "Private AC SUV for all transfers, dedicated open gypsy for safaris.",
    activities: ["Jeep Safari", "Tiger Tracking", "Photography", "Village Walk", "Birding"],
    important: [
      "Safari permits sell out weeks in advance — enquire early.",
      "Wednesday afternoon closures apply in core zones.",
      "Carry original photo ID used at the time of booking.",
      "Monsoon closure applies roughly July to September.",
    ],
    gallery: [IMG.tiger, IMG.forestDark, IMG.safari, IMG.meadowSunset],
    faqs: [
      { q: "How many safaris should I book?", a: "We recommend a minimum of four drives across different zones for the best sighting spread." },
      { q: "Which zone is best?", a: "Tala is the most famous, but Magadhi and Khitauli often deliver quieter, equally rewarding drives." },
      { q: "Is Bandhavgarh crowded?", a: "It is popular, but our naturalists plan routes and timings to keep you away from the clusters." },
      { q: "Can I combine Bandhavgarh with Kanha?", a: "Yes — the classic central India circuit links both parks over six to eight days." },
    ],
  },
  {
    slug: "pench-jungle-experience",
    name: "Pench Jungle Experience",
    destination: "Pench National Park",
    duration: "2 Nights / 3 Days",
    price: "Price on Request",
    img: IMG.forestDark,
    tagline: "Mowgli's forest, on the banks of the Pench river.",
    overview:
      "The teak forests and open meadows of Pench are the original setting of Kipling's jungle tales. A shorter, gentler escape ideal for first-time safari travellers and families.",
    highlights: [
      "Three safaris through teak forest and riverside meadows",
      "The landscape that inspired The Jungle Book",
      "Excellent leopard and wild dog territory",
      "Riverside sundowners at the lodge",
      "Perfect first safari for families",
    ],
    itinerary: [
      { day: "Day 1", title: "River Arrival", detail: "Arrive via Nagpur, settle into your riverside lodge, evening nature walk." },
      { day: "Day 2", title: "Mowgli Country", detail: "Dawn and afternoon safaris through Turia and Karmajhiri — leopard, dhole and over 250 bird species." },
      { day: "Day 3", title: "One Last Drive", detail: "Final morning safari and departure after breakfast." },
    ],
    bestTime: "October to June",
    accommodation: "Comfortable riverside jungle lodges and eco-resorts at Turia gate.",
    transport: "Private AC transfers from Nagpur with dedicated safari gypsy.",
    activities: ["Jeep Safari", "Birdwatching", "Nature Walks", "Riverside Sundowner"],
    important: [
      "Safari permits are subject to availability — book in advance.",
      "Core zones close on Wednesday afternoons.",
      "Valid photo ID required for park entry.",
      "Monsoon closure roughly July to September.",
    ],
    gallery: [IMG.forestDark, IMG.bird, IMG.forestLight, IMG.river],
    faqs: [
      { q: "Is Pench good for a first safari?", a: "It is ideal — open forests, excellent guides and a relaxed pace make it wonderfully accessible." },
      { q: "How do I reach Pench?", a: "Nagpur airport is about 90 kilometres away; we arrange door-to-door private transfers." },
      { q: "What wildlife will I see?", a: "Leopards, wild dogs, gaur, deer and a spectacular range of birdlife are the stars here." },
      { q: "Can I extend the trip?", a: "Yes — many travellers add Tadoba or Kanha for a longer central India circuit." },
    ],
  },
  {
    slug: "satpura-nature-escape",
    name: "Satpura Nature Escape",
    destination: "Satpura National Park",
    duration: "3 Nights / 4 Days",
    price: "Price on Request",
    img: IMG.forestMist2,
    tagline: "Walk the wild — India's most intimate safari landscape.",
    overview:
      "Satpura is where you step out of the vehicle: walking safaris, canoe crossings and boat rides on the Denwa backwaters. A biosphere reserve for travellers who want the forest at its quietest and closest.",
    highlights: [
      "Guided walking safari inside a tiger reserve",
      "Boat safari on the Denwa backwaters",
      "Canoe crossing to enter the core zone",
      "Sloth bear and giant squirrel habitat",
      "Crowd-free wilderness experience",
    ],
    itinerary: [
      { day: "Day 1", title: "Across the Water", detail: "Arrive via Bhopal, cross the Denwa by boat to your lodge. Sunset over the backwaters." },
      { day: "Day 2", title: "On Foot in the Forest", detail: "Morning walking safari with armed naturalists, afternoon boat safari along the backwaters." },
      { day: "Day 3", title: "Core Zone Drive", detail: "Jeep safari into the core zone via canoe crossing — leopard, sloth bear and giant squirrel country." },
      { day: "Day 4", title: "Slow Morning", detail: "Birding walk along the river and departure transfer." },
    ],
    bestTime: "October to April",
    accommodation: "Intimate eco-lodges on the Denwa river, directly facing the reserve.",
    transport: "Private AC transfers from Bhopal with lodge boat and canoe crossings included.",
    activities: ["Walking Safari", "Boat Safari", "Canoe Crossing", "Jeep Safari", "Birding"],
    important: [
      "Walking safaris require moderate fitness and closed shoes.",
      "Safari permits are limited — early booking is essential.",
      "Valid photo ID mandatory for all park entries.",
      "Monsoon closure roughly July to September.",
    ],
    gallery: [IMG.forestMist2, IMG.canoe, IMG.fogHills, IMG.eagle],
    faqs: [
      { q: "Is a walking safari safe?", a: "Yes — walks are led by trained, armed naturalists under strict park protocols." },
      { q: "What makes Satpura different?", a: "It is the rare Indian reserve where you can explore on foot and by boat, not just by jeep." },
      { q: "Will I see tigers?", a: "Satpura has tigers but it is loved most for its quiet — leopards, sloth bears and sheer solitude." },
      { q: "Is it family friendly?", a: "Boat safaris and nature walks suit older children; core walking safaris have age guidelines." },
    ],
  },
  {
    slug: "madhya-pradesh-heritage-journey",
    name: "Madhya Pradesh Heritage Journey",
    destination: "Khajuraho · Orchha · Gwalior Route",
    duration: "7 Nights / 8 Days",
    price: "Price on Request",
    img: IMG.heritageTemple,
    tagline: "Temples, palaces and forgotten empires of the heartland.",
    overview:
      "A sweeping cultural circuit through the great monuments of Madhya Pradesh — the sculpted temples of Khajuraho, the river capital of Orchha, the forts of Gwalior and the ghats of the Narmada.",
    highlights: [
      "UNESCO Western Group of Temples at Khajuraho",
      "Orchha's palaces and riverside cenotaphs",
      "The hilltop fort of Gwalior",
      "Sanchi's Great Stupa and Bhimbetka's rock art",
      "Handloom and cuisine experiences en route",
    ],
    itinerary: [
      { day: "Day 1", title: "Arrive in Khajuraho", detail: "Transfer from the airport, evening light-and-sound show at the Western Group of Temples." },
      { day: "Day 2", title: "Temples of Stone", detail: "Guided exploration of Khajuraho's eastern and western temple groups with a heritage expert." },
      { day: "Day 3", title: "River Road to Orchha", detail: "Drive to Orchha, evening aarti on the Betwa beneath the chhatris." },
      { day: "Day 4", title: "The Hidden Capital", detail: "Jahangir Mahal, Raj Mahal and the Ram Raja temple — a medieval city still breathing." },
      { day: "Day 5", title: "Fort of Gwalior", detail: "The great hill fort, Man Singh palace and the tomb of Tansen." },
      { day: "Day 6", title: "South to Bhopal", detail: "Scenic drive with a stop at Sanchi's Great Stupa, evening by the Upper Lake." },
      { day: "Day 7", title: "Stories in Stone", detail: "Bhimbetka's 30,000-year-old rock shelters and Bhojpur's colossal Shiva temple." },
      { day: "Day 8", title: "Departure", detail: "Transfer to Bhopal airport with breakfast and farewells." },
    ],
    bestTime: "October to March",
    accommodation: "Heritage hotels and boutique havelis chosen for character and comfort.",
    transport: "Private air-conditioned SUV with an experienced driver throughout.",
    activities: ["Heritage Walks", "Temple Tours", "River Aarti", "Museum Visits", "Local Cuisine"],
    important: [
      "Monument entry fees and guide services are arranged by us.",
      "Some sites involve steps and uneven stone — comfortable footwear advised.",
      "Dress modestly for active temples and religious sites.",
      "The circuit can be trimmed or extended to suit your dates.",
    ],
    gallery: [IMG.heritageTemple, IMG.taj, IMG.taj2, IMG.rocks],
    faqs: [
      { q: "Is eight days enough?", a: "It covers the essential circuit comfortably; we can compress to six or stretch to ten on request." },
      { q: "Are guides included?", a: "Licensed heritage guides join you at Khajuraho, Orchha, Sanchi and Gwalior." },
      { q: "What about food?", a: "Breakfast is included daily; we curate local dining recommendations for every stop." },
      { q: "Can this combine with a safari?", a: "Yes — Panna National Park sits beautifully between Khajuraho and the rest of the route." },
    ],
  },
];

export const VEHICLES = {
  cars: [
    { name: "Toyota Innova Crysta", seats: "6–7 Seats", desc: "The long-distance favourite — spacious, comfortable and built for Indian highways.", price: "Price on Request", img: IMG.suv },
    { name: "Maruti Ertiga", seats: "6 Seats", desc: "Easy city-to-outstation comfort for families and small groups.", price: "Price on Request", img: IMG.carDrive },
    { name: "Swift Dzire Sedan", seats: "4 Seats", desc: "Perfect for airport transfers, sightseeing and short outstation runs.", price: "Price on Request", img: IMG.carRoad },
    { name: "Mahindra Thar 4x4", seats: "4 Seats", desc: "For trails, ghats and the roads that lead where the map fades.", price: "Price on Request", img: IMG.jeep },
  ],
  bikes: [
    { name: "Royal Enfield Classic 350", seats: "Rider + Pillion", desc: "The classic way to ride the heartland — unhurried and unmistakable.", price: "Price on Request", img: IMG.moto },
    { name: "Honda Activa Scooty", seats: "Rider + Pillion", desc: "Light, simple and perfect for exploring towns and lakesides at your own pace.", price: "Price on Request", img: IMG.moto3 },
    { name: "Touring Motorcycle", seats: "Rider + Pillion", desc: "Geared machines for multi-day rides across Madhya Pradesh.", price: "Price on Request", img: IMG.moto2 },
  ],
};

export const ADVENTURES = [
  { name: "Trekking", desc: "Satpura ridges, Pachmarhi ravines and forest trails.", img: IMG.hiker },
  { name: "Camping", desc: "Riverside and forest-edge camps under open skies.", img: IMG.tentStars },
  { name: "Nature Trails", desc: "Guided walks through sal, teak and bamboo country.", img: IMG.forestPath },
  { name: "Outdoor Experiences", desc: "Kayaks, cycles and campfires beyond the city edge.", img: IMG.summit },
  { name: "Wildlife Expeditions", desc: "Multi-park expeditions across tiger heartland.", img: IMG.safari },
  { name: "Road Trips", desc: "Curated self-drive and chauffeured routes across MP.", img: IMG.roadTrip },
  { name: "Customized Adventures", desc: "Tell us the journey in your head — we build it.", img: IMG.cliff },
];

export const WHY_US = [
  { title: "Curated Experiences", desc: "Thoughtfully planned journeys designed around the destination.", icon: "map" },
  { title: "Wildlife & Nature Focused", desc: "Discover forests, wildlife and natural landscapes.", icon: "leaf" },
  { title: "Customized Journeys", desc: "Travel plans tailored precisely to your requirements.", icon: "sliders" },
  { title: "Professional Travel Assistance", desc: "Support from planning to the completion of your journey.", icon: "shield" },
  { title: "Transparent Communication", desc: "Clear information and a straightforward enquiry process.", icon: "message" },
];

export const TESTIMONIALS = [
  {
    name: "Ananya Deshpande",
    place: "Pune",
    tour: "Kanha Wildlife Escape",
    text: "Four safaris, three tigers, and a lodge that felt like it grew out of the forest. The planning was invisible — everything simply worked.",
  },
  {
    name: "Rohit & Meera Kulkarni",
    place: "Mumbai",
    tour: "Bandhavgarh Tiger Expedition",
    text: "Our naturalist knew individual tigers by name. We watched a tigress cross the track twenty feet from our gypsy. Unforgettable is an understatement.",
  },
  {
    name: "Sarah Whitmore",
    place: "London",
    tour: "Madhya Pradesh Heritage Journey",
    text: "Khajuraho at dawn, Orchha at dusk, and a team that anticipated everything. The most beautifully organised trip I have taken in India.",
  },
  {
    name: "Vikram Singh Chauhan",
    place: "Delhi",
    tour: "Satpura Nature Escape",
    text: "Walking inside a tiger reserve changes you. Quiet, professional, and deeply respectful of the forest. This is how wildlife travel should feel.",
  },
];

export const STORIES = [
  {
    tag: "Field Notes",
    title: "The Morning the Forest Went Silent",
    read: "6 min read",
    img: IMG.forestMist2,
    excerpt: "A langur's alarm call rolled across the meadow, and everything — deer, birds, wind — held its breath.",
  },
  {
    tag: "Guide",
    title: "Reading Pugmarks: A Beginner's Field Craft",
    read: "8 min read",
    img: IMG.tiger,
    excerpt: "Before you see the tiger, the forest shows you where it has been. Learning to read the signs.",
  },
  {
    tag: "Journey",
    title: "Narmada: Following a River to Its Source",
    read: "10 min read",
    img: IMG.river,
    excerpt: "From the marble gorge of Bhedaghat to the still springs of Amarkantak — one river, a thousand stories.",
  },
];

export const EXPERIENCE_TYPES = [
  "Tiger Safari",
  "Wildlife Tour",
  "Heritage Journey",
  "Adventure & Trekking",
  "Camping",
  "Honeymoon",
  "Family Holiday",
  "Custom Journey",
];
